import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, ArrowRight, Star } from "lucide-react";
import { api } from "@/lib/api";

const TYPE_LABEL = { brand: "Brand", outfitter: "Outfitter", guide: "Guide" };

export function FeaturedPartners() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api.partnerFeatured(6).then((d) => setPartners(d.partners || [])).catch(() => {});
  }, []);

  if (partners.length === 0) return null;

  return (
    <section className="bg-forest text-bone py-16 sm:py-20" data-testid="home-featured-partners">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.25em] text-blaze"><Star size={12} className="fill-blaze" /> Featured Partners</span>
            <h2 className="font-serif text-3xl sm:text-4xl mt-2">Trusted brands, outfitters &amp; guides</h2>
          </div>
          <Link to="/partners" className="inline-flex items-center gap-1.5 text-sm font-semibold text-bone/80 hover:text-blaze transition-colors" data-testid="featured-see-all">See all partners <ArrowRight size={15} /></Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {partners.map((p) => (
            <Link key={p.id} to={p.public_path} className="group block bg-bone/[0.04] border border-bone/10 rounded-xl overflow-hidden hover:border-blaze/50 hover:-translate-y-1 transition-all duration-200" data-testid={`featured-card-${p.slug}`}>
              <div className="relative h-32 bg-charcoal overflow-hidden">
                {p.cover ? <img src={p.cover} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" /> : <div className="w-full h-full bg-gradient-to-br from-forest-2 to-charcoal" />}
                <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-wide bg-blaze text-white px-2 py-0.5 rounded-full">{TYPE_LABEL[p.partner_type]}</span>
              </div>
              <div className="p-4 flex gap-3 -mt-8 relative">
                <div className="w-14 h-14 rounded-xl bg-bone border border-bone/20 shadow overflow-hidden grid place-items-center shrink-0">
                  {p.logo ? <img src={p.logo} alt={p.name} className="w-full h-full object-cover" /> : <span className="font-serif text-xl text-forest">{(p.name || "H")[0]}</span>}
                </div>
                <div className="min-w-0 pt-8">
                  <div className="flex items-center gap-1.5">
                    <h3 className="font-serif text-lg truncate">{p.name}</h3>
                    {(p.verification_status || "").startsWith("verified") && <BadgeCheck size={15} className="text-blaze shrink-0" />}
                  </div>
                </div>
              </div>
              {p.tagline && <p className="px-4 pb-4 -mt-1 text-sm text-bone/65 line-clamp-2">{p.tagline}</p>}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
